// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Program } from './program';
import { ProgramAllowanceAddonException } from './program-allowance-addon-exception';
import { ProgramAllowanceFeatureException } from './program-allowance-feature-exception';
import { ProgramAllowanceUserGroupMap } from './program-allowance-user-group-map';
import { ProgramAllowanceUserLog } from './program-allowance-user-log';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramAllowance extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  override toString() {
    return `${this.entityType.shortName}: ${this.name}` ;
  }

  get fullName() {
    return this.program.name + ": " + this.name;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Boolean */
  allowOverAllowancePurchases!: boolean;
  /** Decimal */
  allowanceAmt!: number;
  /** Decimal */
  estimatedFreightChargeRate?: number;
  /** Boolean */
  isFreightChargedToAllowance!: boolean;
  /** String(60) */
  name!: string;
  /** Guid FK program */
  programId!: string;
  /** Binary */
  rowVersion!: any;
  /** FK programId */
  program!: Program;
  /** Inv FK programAllowanceId */
  programAllowanceAddonExceptions!: ProgramAllowanceAddonException[];
  /** Inv FK programAllowanceId */
  programAllowanceFeatureExceptions!: ProgramAllowanceFeatureException[];
  /** Inv FK programAllowanceId */
  programAllowanceUserGroupMaps!: ProgramAllowanceUserGroupMap[];
  /** Inv FK programAllowanceId */
  programAllowanceUserLogs!: ProgramAllowanceUserLog[];
}

